(function (angular) {
    'use strict';

    angular.module("smsReports")
        .controller("VerifyReportsCtrl", [
            "$scope", '$stateParams', 'smsVerifyService', 'growlService', 'chartsService', 'chartFactoryService', function ($scope, $stateParams, smsVerifyService, growlService, chartsService, chartFactoryService) {

                $scope.statuses = [
                    { id: 'locked', label: "Locked" },
                    { id: 'expired', label: "Expired" },
                    { id: 'verified', label: "Verified" },
                    { id: 'notVerified', label: "Not Verified" }
                ];

                $scope.colors = {
                    locked: ['#3023ae', '#c86dd7'],
                    expired: ['#0a227f', '#1a8ade'],
                    verified: ['#429321', '#b4ec51'],
                    notVerified: ['#fe0606', '#7f0a15']
                };
                $scope.noData = {};
                var mainData = {};
                var data = {};

                Chart.elements.Rectangle.prototype.draw = chartFactoryService.roundedCornersBars;

                Chart.pluginService.register(chartFactoryService.fillScatteredTimeScaleDataPlugin);


                $scope.createdFrom = { value: undefined };
                $scope.createdTo = { value: undefined };

                $scope.onDateRangeChange = function (from, to) {
                    $scope.createdFrom.value = moment(from).toDate();
                    $scope.createdTo.value = moment(to).toDate();

                    $scope.getData();
                };

                var maxYvalue = 0;

                $scope.getData = function () {
                    $scope.noData.scatter = false;
                    $scope.noData.bar = false;
                    chartsService.setData($scope.createdFrom, $scope.createdTo);
                    $scope.queryBy = chartsService.getSampling(true);
                    maxYvalue = 0;
                    smsVerifyService.getQueriedData($stateParams.pickedApiSpaceId, chartsService.data).then(function (result) {
                        mainData = {};
                        data = {};
                        var scatterIsZeroed = [];

                        $scope.statuses.forEach(function (status) {

                            mainData[status.id] = [];

                            if (result && result.length > 0) {
                                result.forEach(function (el) {
                                    var val = 0;
                                    if (el[status.id]) {
                                        val = el[status.id] ? el[status.id] : 0;
                                    }
                                    mainData[status.id].push({ x: moment(el.date), y: val });
                                    maxYvalue = maxYvalue > val ? maxYvalue : val;
                                });

                            } else {
                                $scope.noData.scatter = true;
                            }


                            data[status.id] = _.reduce(result, function (sum, el) {
                                if (el[status.id]) {
                                    return sum + el[status.id];
                                } else {
                                    return sum;
                                }
                            }, 0);

                            scatterIsZeroed.push(_.some(mainData[status.id], function (el) { return el.y != 0; }));

                        });


                        $scope.noData.scatter = _.compact(scatterIsZeroed).length < 1;

                        $scope.labels = {};

                        $scope.data = {};

                        $scope.labels = $scope.statuses.map(function (status) {
                            return status.label;
                        });
                        $scope.data.bar = _.flatMap(data);
                        $scope.noData.bar = _.compact($scope.data.bar).length < 1;

                        growlService.success('Data correctly downloaded ', 10, true);
                        $scope.displayVariables();

                    }).catch(function (error) {
                        growlService.danger("Data didn't downloaded due to: " + error.statusText);
                        console.error(error);
                    });
                };

                var ctx = {};
                var charts = {};
                var chartData = {};

                $scope.displayVariables = function () {
                    var barGradientArray = [];
                    var barGradient = {};
                    var lineGradientSet = {};

                    ctx.main = document.getElementById('scatter');
                    ctx.bar = document.getElementById('bar');

                    if (ctx.bar && ctx.main) {
                        ctx.barCanvas = ctx.bar;
                        ctx.bar = ctx.bar.getContext("2d");
                        ctx.main = ctx.main.getContext("2d");

                        // Creating gradients

                        $scope.statuses.forEach(function (status) {

                            barGradient[status.id] = ctx.bar.createLinearGradient(0, 0, 400, 0);
                            lineGradientSet[status.id] = ctx.main.createLinearGradient(0, 0, 400, 0);

                            lineGradientSet[status.id].addColorStop(0, $scope.colors[status.id][0]);
                            lineGradientSet[status.id].addColorStop(1, $scope.colors[status.id][1]);

                            barGradient[status.id].addColorStop(0, $scope.colors[status.id][0]);
                            barGradient[status.id].addColorStop(1, $scope.colors[status.id][1]);

                            barGradientArray.push(barGradient[status.id]);

                        });


                        //  SCATTER CHART  
                        var dataSets = [];

                        _.forEach(mainData, function (data, key) {
                            var mainLabel = $scope.statuses.find(function (mainStatus) {
                                return mainStatus.id === key;
                            }).label;
                            dataSets.push(chartFactoryService.singleChannelDataSetMain(mainLabel, data, lineGradientSet[key], lineGradientSet[key], $scope.colors[key][1]));
                        });

                        chartData.main = {
                            datasets: dataSets
                        };

                        if (charts.main) {
                            charts.main.destroy();
                        }


                        charts.main = new Chart(ctx.main, {
                            type: "scatter",
                            data: chartData.main,
                            tooltips: false,
                            options: chartFactoryService.singleChannelDataOptionsMain(chartsService.data.from.value, chartsService.data.to.value, chartsService.data.by, maxYvalue)
                        });



                        // BAR CHART 
                        chartData.bar = {
                            labels: $scope.labels,
                            datasets: [chartFactoryService.singleChannelDataSetBar(barGradientArray, $scope.data.bar)]
                        };

                        if (charts.bar) {
                            charts.bar.destroy();
                        }

                        ctx.barCanvas.style.width = "100%";
                        ctx.barCanvas.width = ctx.barCanvas.offsetWidth;

                        charts.bar = new Chart(ctx.bar, {
                            type: 'horizontalBar',
                            data: chartData.bar,
                            tooltips: false,
                            options: chartFactoryService.verifyDataOptionsBar
                        });

                    }
                };


                $scope.selectedDateRange = "7Days";
            }
        ]);

})(window.angular);